import locationDateInformation from './location-date-information';
import {generalInformation} from './general-information';
import {buildSummedGeneralInformation} from './sumed-general-information';
import {detailedInformation} from './detailed-information';
import {buildSummedDetailedInformation} from './sumed-detailed-information';
import {buildHeader} from './header';
import topLeft from './top-left';
import leaseNotes from './lease-notes';

let cloneDeep = require('lodash.clonedeep');

export function buildRRTab(tab) {
    return cloneDeep({
        name: tab === 'current-rr-tab' ? 'Current Rent Roll' : 'Proforma Rent Roll',
        tables: {
            'location-date-information': locationDateInformation,
            'header': buildHeader(tab),
            'top-left': topLeft,
            'general-information': generalInformation,
            'sumed-general-information': buildSummedGeneralInformation(tab),
            'detailed-information': detailedInformation,
            'sumed-detailed-information': buildSummedDetailedInformation(tab),
            'lease-notes': leaseNotes,
        }
    });
}
